import { createContext } from "react";
import { useEnsureContext } from "@madmedical/utils";
export var ModalState;
(function (ModalState) {
    ModalState[ModalState["Closed"] = 0] = "Closed";
    ModalState[ModalState["Measure"] = 1] = "Measure";
    ModalState[ModalState["Feeling"] = 2] = "Feeling";
    ModalState[ModalState["Edit"] = 3] = "Edit";
    ModalState[ModalState["Delete"] = 4] = "Delete";
})(ModalState || (ModalState = {}));
const PregnancyContext = createContext(undefined);
export const PregnancyProvider = PregnancyContext.Provider;
export const usePregnancy = () => useEnsureContext(PregnancyContext);
